import { Component, Input, Self, Optional, EventEmitter, Output, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'apc-form-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  host: { class: 'apc-form-select' },
})
export class SelectComponent implements ControlValueAccessor {
  @Input() loading: boolean = false;
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() class: string;
  @Input() items: any;
  @Input() optionName: any = 'name';
  @Input() optionValue: any = 'identifier';
  @Input() optionDescription: Array<string>;
  @Input() placeholder: any;
  @Input() rows: string;
  @Input() onEdit: boolean;
  @Input() isObject: boolean = true;
  @Input() autogenerated: boolean = false;
  @Input() hideDescTitle: boolean = false;
  @Input() activeDescToltip: boolean = false;

  @Output() isChanged = new EventEmitter<any>();
  @Output() isOpen = new EventEmitter<any>();
  @ViewChild('select') select;
  @ViewChild('input') input;
  @ViewChild('descriptionTooltip') descriptionTooltip: ElementRef;

  @ViewChild('t') t: NgbTooltip;

  value: any = null;

  @Input() renderValue: string = '';
  public currentType: string = 'select';

  constructor(
    @Self() @Optional() public ngControl: NgControl, 
    private cdRef: ChangeDetectorRef
  ) {
    this.ngControl && (this.ngControl.valueAccessor = this);
  }

  setSelectType() {
    this.currentType = 'select';
    this.cdRef.detectChanges();
  }

  handleSelectInputEdit() {
    if (
      (this.select && this.select.element.closest('.editForm')) ||
      (this.input && this.input.nativeElement.closest('.editForm'))
    ) {
      this.currentType = 'select';
    } else {
      this.currentType = 'text';
    }
    this.cdRef.detectChanges();
  }
  emitSelect() {
    this.isOpen.emit(true);
  }

  public onChangeFn = (_: any) => {};
  public onTouchedFn = () => {};

  public registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(obj: any): void {
    this.value = obj;
    if(this.isObject) {
    this.renderValue = this.value ? this.value[this.optionName] : null;
    } else {
      this.renderValue = this.value;
    }
  }

  public onChange() {
    this.onChangeFn(this.value);
    this.renderValue = this.value;
    this.isChanged.emit(this.value);
    this.hideTooltip();
  }

  // work only with date input type
  clearDate() {
    this.value = null;
    this.onChangeFn(this.value);
  }

  showErrorTooltip() {
    this.t?.open();
  }

  ngAfterViewInit(){
    if(this.descriptionTooltip){
      console.log("NAME:", this.select);
      console.log("DESC:", this.descriptionTooltip);
    }
    
  }
  showTooltip(opt){
    if(this.descriptionTooltip){
      this.descriptionTooltip.nativeElement.classList.remove("removeDesc");
      this.addDesc(this.descriptionTooltip.nativeElement.classList,"hoverDesc"); 
      if(opt.description){     
        this.descriptionTooltip.nativeElement.innerHTML = "<p class='titleTooltip'><b>"+opt.name+"</b></p>"+opt.description;
      }else{
        this.descriptionTooltip.nativeElement.innerHTML = "No description";

      }
    }   
  }
  addDesc(list,cl){
    if(!list.contains(cl)){
      this.descriptionTooltip.nativeElement.classList.add(cl); 
    }
  }
  hideTooltip(){
    if(this.descriptionTooltip){
      this.addDesc(this.descriptionTooltip.nativeElement.classList,"removeDesc")
      this.descriptionTooltip.nativeElement.classList.remove("hoverDesc"); 
    }  
  }

  getNgControlErrors(){
    if(this.ngControl != null && typeof this.ngControl != typeof undefined){
      if(this.ngControl.errors != null && typeof this.ngControl.errors != typeof undefined){
        return this.ngControl.errors
      }
    }
    return [];
  }
  

}
